import { API_ENDPOINTS } from "config/config";
import { buildAnalyticsQueryParams } from "utils/analyticsQueryParams";

export const buildVidalyticsAnalyticsQueryParams = buildAnalyticsQueryParams;

export const getVidalyticsAnalytics = async (api, params) => {
  const response = await api.get(API_ENDPOINTS.VIDALYTICS_ANALYTICS, {
    params: buildVidalyticsAnalyticsQueryParams(params),
  });
  return response.data.data;
};
